import Header from './Header.js';

const initHeaderComponent = () => {
  const elements = Array.from(document.querySelectorAll('[data-component="header"]'));

  elements.forEach((element) => {
    new Header(element);
  });
};

export default initHeaderComponent;
